import { NotificationModel as Notification } from "components/Notifications";

export interface LayoutState {
    loading: string[];
    notification?: Notification;
}
